import React from 'react';

const studentData = [
  {
    name: 'Kanishk Mahajan',
    contact: '7710781047',
    rollNo: '2330264',
    branch: 'ECE',
    membershipId: '100975045',
    email: 'kanishkm445@gmail.com',
  },
  {
    name: 'Mimisha',
    contact: '9707925876',
    rollNo: '2330268',
    branch: 'ECE',
    membershipId: '101904323',
    email: 'paulmimisha50@gmail.com',
  },
  {
    name: 'Madhu Sharma',
    contact: '8708793810',
    rollNo: '2420031',
    branch: 'ECE',
    membershipId: '102118426',
    email: 'madhumoudgil657@gmail.com',
  },
  {
    name: 'Chandra',
    contact: '7876504680',
    rollNo: '2330250',
    branch: 'ECE',
    membershipId: '102118459',
    email: 'chandrathakur3456@gmail.com',
  },
  {
    name: 'Uday Sharma',
    contact: '9034683172',
    rollNo: '2230963',
    branch: 'ECE',
    membershipId: '100243362',
    email: 'uday777sh@gmail.com',
  },
  {
    name: 'Janvi',
    contact: '9878603724',
    rollNo: '2420024',
    branch: 'ECE',
    membershipId: '101904296',
    email: 'officialjanvi2007@gmail.com',
  },
  {
    name: 'Happy',
    contact: '8572810317',
    rollNo: '2330256',
    branch: 'ECE',
    membershipId: '102075829',
    email: 'ihappy2502@gmail.com',
  },
  {
    name: 'Yeshta',
    contact: '9053750619',
    rollNo: '2330864',
    branch: 'R&AI',
    membershipId: '100985110',
    email: 'syeshta@gmail.com',
  },
  {
    name: 'Diksha',
    contact: '9855631288',
    rollNo: '2420015',
    branch: 'ECE',
    membershipId: '102118479',
    email: 'ddhiman2006@gmail.com',
  },
  {
    name: 'Prashant',
    contact: '7807257885',
    rollNo: '2420041',
    branch: 'ECE',
    membershipId: '102118402',
    email: 'pc587110@gmail.com',
  },
  {
    name: 'Yash Lohia',
    contact: '6376313275',
    rollNo: '2420061',
    branch: 'ECE',
    membershipId: '102118439',
    email: 'lohiayash4656@gmail.com',
  },
  {
    name: 'Aman Sakhwal',
    contact: '7807441332',
    rollNo: '2420000',
    branch: 'ECE',
    membershipId: '102118336',
    email: 'sakhwalaman2809@gmail.com',
  },
  {
    name: 'Moinak Dey',
    contact: '9123811801',
    rollNo: '2330838',
    branch: 'R&AI',
    membershipId: '100974639',
    email: 'moinakdey21@gmail.com',
  },
  {
    name: 'Mansi Aggarwal',
    contact: '6283642893',
    rollNo: '2420032',
    branch: 'ECE',
    membershipId: '102118480',
    email: 'mansiaggarwal116@gmail.com',
  },
  {
    name: 'Mahi',
    contact: '7990640702',
    rollNo: '2420044',
    branch: 'ECE',
    membershipId: '102118408',
    email: 'raghuvanshimahi6@gmail.com',
  },
  {
    name: 'Shreshtha',
    contact: '9808554866',
    rollNo: '2420053',
    branch: 'ECE',
    membershipId: '102126704',
    email: 'shreshtha2228@gmail.com',
  },
  {
    name: 'Deepika',
    contact: '7355862622',
    rollNo: '2420013',
    branch: 'ECE',
    membershipId: '102118405',
    email: 'deepikapoonia943@gmail.com',
  },
  {
    name: 'Vishwas Miglani',
    contact: '7307416770',
    rollNo: '2230967',
    branch: 'ECE',
    membershipId: '100243276',
    email: 'vishwasmiglani.connect@gmail.com',
  },
  {
    name: 'Aditya Nandan',
    contact: '8540902505',
    rollNo: '2420369',
    branch: 'ECE',
    membershipId: '101029276',
    email: 'adityanandan2548@gmail.com',
  },
  {
    name: 'Anush Kumar',
    contact: '9103700723',
    rollNo: '2420006',
    branch: 'ECE',
    membershipId: '102171312',
    email: 'anushk862@gmail.com',
  },
  {
    name: 'Bhupider Mangotra',
    contact: '9797763405',
    rollNo: '2420011',
    branch: 'ECE',
    membershipId: '102172961',
    email: 'bhupindermangotra048@gmail.com',
  },
  {
    name: 'Amit Badyal',
    contact: '8082457485',
    rollNo: '2420001',
    branch: 'ECE',
    membershipId: '102172963',
    email: 'badyalamitbadyla@gmail.com',
  },
  {
    name: 'Murtaza Ahmed',
    contact: '8082376544',
    rollNo: '2420036',
    branch: 'ECE',
    membershipId: '102172964',
    email: 'murtazahmed056@gmail.com',
  },
].map((student, index) => ({ ...student, index: index + 1 })); 
//function is used to iterate over the studentData array 
//and add an index property to each student object. 
//The index property is set to the current index of the array 
//plus one, making it a 1-based index instead of the default 0-based index.

function StudentTeam() {
  return (
    <div className="container mx-auto pt-20 p-1 sm:p-4 ">
    <h1 className="text-2xl sm:text-3xl font-bold mb-4 text-center uppercase">Student Team</h1>

    <div className="mt-4 p-2 sm:p-4">
      <div className="flex flex-wrap justify-center mb-5">
        {[
          { name: "Kanishk Mahajan", role: "Chairperson" },
          { name: "Yeshta", role: "Co-Chairperson" },          
          { name: "Yash Lohia & Moinak Dey", role: "Secretary" },
          { name: "Prashant & Aman Sakhwal", role: "Treasurer" },
          { name: "Bhupider Mangotra & Murtaza Ahmed", role: "WebMaster" },
          { name: "Madhu Sharma & Happy & Anush Kumar", role: "Publicity Committee" },
          { name: "Chandra & Aditya Nandan & Amit Badyal", role: "Program Committee" }
        ].map((member, index) => (
          <div key={index} className="w-full sm:w-1/2 lg:w-1/3 p-2 sm:p-4 text-lg sm:text-2xl mb-4 flex flex-col items-center">
            <span className="font-semibold">{member.name}</span>
            <span>{member.role}</span>
          </div>
        ))}
      </div>
    </div>

    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200">
        <thead>
          <tr className="bg-red-600 text-white uppercase text-xs sm:text-sm leading-normal">
            <th className="py-2 sm:py-3 px-2 sm:px-6 text-left">Sr. No.</th>
            <th className="py-2 sm:py-3 px-2 sm:px-6 text-left">Name of the Student Member</th>
            <th className="py-2 sm:py-3 px-2 sm:px-6 text-left">Contact Number</th>
            <th className="py-2 sm:py-3 px-2 sm:px-6 text-left">University Roll No.</th>
            <th className="py-2 sm:py-3 px-2 sm:px-6 text-left">Branch</th>
            <th className="py-2 sm:py-3 px-2 sm:px-6 text-left">Membership ID</th>
            <th className="py-2 sm:py-3 px-2 sm:px-6 text-left">Mail ID</th>
          </tr>
        </thead>
        <tbody className="text-xs sm:text-sm font-light">
          {studentData.map((student) => (
            <tr key={student.index} className="border-b border-gray-200 hover:bg-gray-100 font-semibold">
              <td className="py-2 sm:py-3 px-2 sm:px-6 text-left whitespace-nowrap">{student.index}</td>
              <td className="py-2 sm:py-3 px-2 sm:px-6 text-left">{student.name}</td>
              <td className="py-2 sm:py-3 px-2 sm:px-6 text-left">{student.contact}</td>
              <td className="py-2 sm:py-3 px-2 sm:px-6 text-left">{student.rollNo}</td>
              <td className="py-2 sm:py-3 px-2 sm:px-6 text-left">{student.branch}</td>
              <td className="py-2 sm:py-3 px-2 sm:px-6 text-left">{student.membershipId}</td>
              <td className="py-2 sm:py-3 px-2 sm:px-6 text-left">{student.email}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
  );
}

export default StudentTeam;